import { useTranslation } from 'next-i18next'
import React from 'react'

import s from './landing.module.css'
import { heatLevels } from './persona'

/** Minhas Lutas + ELO: stats e tabela de lutas (dados ilustrativos). */
export function Fights() {
  const { t } = useTranslation('landing')

  const fights: Array<[string, string, boolean, string]> = [
    [t('fights.row1Event'), 'Goodfellas', true, t('fights.row1Result')],
    [t('fights.row2Event'), 'IBJJF', true, t('fights.row2Result')],
    [t('fights.row3Event'), 'AJP', false, t('fights.row3Result')],
    [t('fights.row4Event'), 'CBJJ', true, t('fights.row4Result')],
  ]

  return (
    <section className={s.sec} id="lutas">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 16,
        }}
      >
        <div>
          <p className={`${s.kick} text-brand`}>
            <span className={s.kbar} />
            {t('fights.kicker')}
          </p>
          <h2
            className={`${s.d} ${s.h2} text-ink`}
            style={{ margin: '22px 0 0' }}
          >
            {t('fights.title1')}
            <br />
            <span className={s.outR}>{t('fights.title2')}</span>
          </h2>
        </div>
        <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
          {[
            ['14–3', t('fights.stat1')],
            ['1.482', t('fights.stat2')],
            ['#3', t('fights.stat3')],
          ].map(([num, label]) => (
            <div className={s.stat} key={label}>
              <div className={`${s.statn} text-brand`}>{num}</div>
              <div className={s.statl}>{label}</div>
            </div>
          ))}
        </div>
      </div>

      <p className={s.lead} style={{ marginTop: 16 }}>
        {t('fights.lead')}
      </p>

      <div style={{ marginTop: 44 }}>
        {fights.map(([event, org, won, decision], i) => (
          <div
            className={s.fightrow}
            key={event}
            style={i === 0 ? { borderTop: '3px solid #141414' } : undefined}
          >
            <span style={{ fontWeight: 600 }}>{event}</span>
            <span className={s.orgtag}>{org}</span>
            <span className={`${s.wtag} ${won ? s.wv : s.wd}`}>
              {won ? t('fights.win') : t('fights.loss')}
            </span>
            <span>{decision}</span>
          </div>
        ))}
      </div>
    </section>
  )
}

/** Treinos + streaks: stats e heatmap de 126 células em 5 níveis de vermelho. */
export function Trainings() {
  const { t } = useTranslation('landing')
  const levels = heatLevels()

  return (
    <section className={`bg-warm-bg ${s.sec}`} id="treinos">
      <p className={`${s.kick} text-brand`}>
        <span className={s.kbar} />
        {t('trainings.kicker')}
      </p>
      <h2 className={`${s.d} ${s.h2} text-ink`} style={{ margin: '22px 0 0' }}>
        {t('trainings.title1')}
        <br />
        <span className={s.outR}>{t('trainings.title2')}</span>
      </h2>
      <div
        style={{
          display: 'flex',
          gap: 24,
          flexWrap: 'wrap',
          marginTop: 16,
          justifyContent: 'space-between',
          alignItems: 'flex-end',
        }}
      >
        <p className={s.lead}>{t('trainings.lead')}</p>
        <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
          {[
            ['126', t('trainings.stat1')],
            ['23', t('trainings.stat2')],
            ['4,2', t('trainings.stat3')],
          ].map(([num, label]) => (
            <div className={s.stat} key={label}>
              <div className={`${s.statn} text-ink`}>{num}</div>
              <div className={s.statl}>{label}</div>
            </div>
          ))}
        </div>
      </div>

      <div
        className={s.heat}
        style={{ marginTop: 44, maxWidth: 920 }}
        role="img"
        aria-label={t('trainings.heatmapAria')}
      >
        {levels.map((level, i) => (
          <div key={i} className={`${s.hc} ${s[`l${level}`]}`} />
        ))}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          marginTop: 12,
          fontSize: 13,
          color: '#8b8b8b',
        }}
      >
        <span>{t('trainings.less')}</span>
        {[0, 1, 2, 3, 4].map((level) => (
          <span
            key={level}
            className={`${s.hc} ${s[`l${level}`]}`}
            style={{ width: 14 }}
          />
        ))}
        <span>{t('trainings.more')}</span>
      </div>
    </section>
  )
}

/** Academias são as arenas: 3 cards + banner AO VIVO com kit de streaming. */
export function Academies() {
  const { t } = useTranslation('landing')

  return (
    <section className={s.sec} id="academias">
      <p className={`${s.kick} text-brand`}>
        <span className={s.kbar} />
        {t('academies.kicker')}
      </p>
      <h2 className={`${s.d} ${s.h2} text-ink`} style={{ margin: '22px 0 0' }}>
        {t('academies.title1')}
        <br />
        <span className={s.outR}>{t('academies.title2')}</span>
      </h2>
      <p className={s.lead} style={{ marginTop: 16 }}>
        {t('academies.lead')}
      </p>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(260px,1fr))',
          gap: 20,
          marginTop: 44,
        }}
      >
        {[
          ['GF', t('academies.c1Title'), t('academies.c1Copy')],
          ['OSS', t('academies.c2Title'), t('academies.c2Copy')],
          ['19H', t('academies.c3Title'), t('academies.c3Copy')],
        ].map(([mono, title, copy]) => (
          <div className={s.gcard} key={mono}>
            <div className={s.gnum}>{mono}</div>
            <div className={s.ft}>{title}</div>
            <p className={s.fp}>{copy}</p>
          </div>
        ))}
      </div>

      <div
        className="bg-brand"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 24,
          borderRadius: 24,
          padding: '44px 40px',
          marginTop: 24,
        }}
      >
        <div style={{ maxWidth: 620 }}>
          <p className={`${s.kick} text-white`}>
            <span className={s.livedot} />
            {t('academies.liveKicker')}
          </p>
          <h3
            className={`${s.d} text-white`}
            style={{
              fontSize: 'clamp(34px,3.8vw,58px)',
              margin: '14px 0 10px',
            }}
          >
            {t('academies.liveTitle1')}
            <br />
            <span className={s.outW}>{t('academies.liveTitle2')}</span>
          </h3>
          <p
            className={s.lead}
            style={{ fontSize: 17, margin: 0, color: 'rgba(255,255,255,.85)' }}
          >
            {t('academies.liveLead')}
          </p>
        </div>
        <a className={`${s.btn} ${s.btnW}`} href="#baixar">
          {t('academies.liveCta')}
        </a>
      </div>
    </section>
  )
}
